// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF-InfoTooltip-labelWrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.FF-InfoTooltip-container {
  height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/InfoIcons/InfoTooltip/InfoTooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB","sourcesContent":[".FF-InfoTooltip-labelWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n.FF-InfoTooltip-container {\n  height: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
